"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = EmptyFolder;

var _react = _interopRequireWildcard(require("react"));

var _immutable = _interopRequireDefault(require("immutable"));

var _I18n = _interopRequireDefault(require("I18n"));

var _FormattedReactMessage = _interopRequireDefault(require("I18n/components/FormattedReactMessage"));

var _UIImage = _interopRequireDefault(require("UIComponents/image/UIImage"));

var _FileManagerImages = require("FileManagerImages");

var _AddFolderButton = _interopRequireDefault(require("FileManagerLib/components/browser/AddFolderButton"));

function EmptyFolder(props) {
  var onCreateFolder = props.onCreateFolder,
      folders = props.folders,
      selectedFolder = props.selectedFolder;
  return _react.default.createElement("div", {
    className: "text-center"
  }, _react.default.createElement(_UIImage.default, {
    className: "m-y-10",
    width: 100,
    src: (0, _FileManagerImages.getImageUrl)('empty-folder'),
    responsive: false
  }), _react.default.createElement("h5", null, _I18n.default.text('FileManagerLib.emptyFolder.message')), _react.default.createElement("p", null, _react.default.createElement(_FormattedReactMessage.default, {
    message: "FileManagerLib.emptyFolder.hint",
    options: {
      button: _react.default.createElement(_AddFolderButton.default, {
        folders: folders,
        selectedFolder: selectedFolder,
        onCreate: onCreateFolder
      }, _I18n.default.text('FileManagerLib.emptyFolder.inlineButtonText'))
    }
  })));
}

EmptyFolder.propTypes = {
  folders: _react.PropTypes.instanceOf(_immutable.default.List).isRequired,
  selectedFolder: _react.PropTypes.instanceOf(_immutable.default.Map),
  onCreateFolder: _react.PropTypes.func.isRequired
};
module.exports = exports.default;